import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faArrowUp, faArrowDown, faSync, faToggleOn, faToggleOff } from '@fortawesome/free-solid-svg-icons';
import openPayLogo from '../../../../src/images/openPayLogo.png';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import 'jspdf-autotable';
import baseURL from '../../url';
import NewPasarelaPagos from '../NewPasarelaPagos/NewPasarelaPagos';
import { adminFetch } from '../../../utils/api';
export default function PasarelaPagosData() {
    const [pasarelasPago, setPasarelasPago] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [storeId, setNuevoStoreId] = useState('');
    const [gatewayName, setNuevoGatewayName] = useState('');
    const [gatewayType, setNuevoGatewayType] = useState('');
    const [publicKey, setNuevoPublicKey] = useState('');
    const [secretKey, setNuevoSecretKey] = useState('');
    const [merchantId, setNuevoMerchantId] = useState('');
    const [webhookUrl, setNuevoWebhookUrl] = useState('');
    const [environment, setNuevoEnvironment] = useState('');
    const [priority, setNuevoPriority] = useState('');
    const [configJson, setNuevoConfigJson] = useState('');
    const [pasarelaPago, setPasarelaPago] = useState({});
    const [selectedSection, setSelectedSection] = useState('texto');

    useEffect(() => {
        cargarPasarelasPago();
    }, []);


    const cargarPasarelasPago = () => {
        adminFetch(`${baseURL}/api/admin/pasarelas`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setPasarelasPago(data.pasarelasPagos || []);
            })
            .catch(error => console.error('Error al cargar pasarelas de pagos:', error));
    };


    const actualizarEstatusPasarela = (idPaymentGateway,estatus) => {
        const payload = {
            isActive: estatus === 1 ? 0 : 1 
        };
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡Cambiarás el estatus de la pasarela de pagos!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, desactivar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                adminFetch(`${baseURL}/api/admin/pasarelas/${idPaymentGateway}/estatus`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload),
                })
                    .then(response => response.json())
                    .then(data => {
                        Swal.fire(
                            '¡Actualizado!',
                            data.mensaje,
                            'success'
                        );
                        cargarPasarelasPago();
                    })
                    .catch(error => {
                        console.error('Error al actualizar pasarela:', error);
                        toast.error(error);
                    });
            }
        });
    };

    const abrirModal = (item) => {
        setPasarelaPago(item);
        setNuevoStoreId(item.storeId);
        setNuevoGatewayName(item.gatewayName);
        setNuevoGatewayType(item.gatewayType);
        setNuevoPublicKey(item.publicKey);
        setNuevoSecretKey(item.secretKey);
        setNuevoMerchantId(item.merchantId);
        setNuevoWebhookUrl(item.webhookUrl);
        setNuevoEnvironment(item.environment);
        setNuevoPriority(item.priority);
        setNuevoConfigJson(item.configJson);
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
    };

    const handleUpdateText = (idPaymentGateway) => {

        const payload = {
            storeId,
            gatewayName,
            gatewayType,
            publicKey,
            secretKey,
            merchantId,
            webhookUrl,
            environment,
            priority,
            configJson,
        };

        adminFetch(`${baseURL}/api/admin/pasarelas/${idPaymentGateway}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    Swal.fire(
                        'Error!',
                        data.error,
                        'error'
                    );
                } else {
                    Swal.fire(
                        'Editado!',
                        data.mensaje,
                        'success'
                    );
                    cargarPasarelasPago();
                    cerrarModal();
                }
            })
            .catch(error => {
                toast.error(error.message);
            });
    };



    const handleSectionChange = (section) => {
        setSelectedSection(section);
    };
    return (
        <div>

            <ToastContainer />

            <NewPasarelaPagos />

            {modalVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>

                            <div className='deFlexBtnsModal'>
                                <button
                                    className={selectedSection === 'texto' ? 'selected' : ''}
                                    onClick={() => handleSectionChange('texto')}
                                >
                                    Editar Pasarela de Pagos
                                </button>

                            </div>
                            <span className="close" onClick={cerrarModal}>
                                &times;
                            </span>
                        </div>
                        <div className='sectiontext' style={{ display: selectedSection === 'texto' ? 'flex' : 'none' }}>
                            <form className='flexGrap' onSubmit={(e) => crear(e)}>
                                <fieldset>
                                    <legend>Nombre Pasarela</legend>
                                    <input
                                        type='text'
                                        name='gatewayName'
                                        value={gatewayName !== '' ? gatewayName : pasarelaPago.gatewayName}
                                        onChange={(e) => setNuevoGatewayName(e.target.value)}
                                        required
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Tipo</legend>
                                     <img src={openPayLogo} alt='OpenPay Logo' height={30} width={80}/>
                                </fieldset>
                                <fieldset>
                                    <legend>Clave Publica</legend>
                                    <input
                                        type='text'
                                        name='publicKey'
                                        value={publicKey}
                                        onChange={(e) => setNuevoPublicKey(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Clave Secreta</legend>
                                    <input
                                        type='text'
                                        name='secretKey'
                                        value={secretKey}
                                        onChange={(e) => setNuevoSecretKey(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Id Comerciante</legend>
                                    <input
                                        type='text'
                                        name='merchantId'
                                        value={merchantId}
                                        onChange={(e) => setNuevoMerchantId(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Webhook Url</legend>
                                    <input
                                        type='text'
                                        name='webhookUrl'
                                        value={webhookUrl}
                                        onChange={(e) => setNuevoWebhookUrl(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Ambiente</legend>
                                    <select
                                        value={environment}
                                        onChange={(e) => setNuevoEnvironment(e.target.value)}
                                    >
                                        <option value="sandbox">Pruebas</option>
                                        <option value="production">Producción</option>
                                    </select>
                                </fieldset>
                                <fieldset>
                                    <legend>Prioridad</legend>
                                    <input
                                        type='number'
                                        name='priority'
                                        value={priority}
                                        onChange={(e) => setNuevoPriority(e.target.value)}
                                    />
                                </fieldset>
                            </form>




                            <button className='btnPost' onClick={() => handleUpdateText(pasarelaPago.idPaymentGateway)} >Guardar </button>

                        </div>




                    </div>
                </div>
            )}
            <div className='table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>Id Pasarela</th>
                            <th>Nombre</th>
                            <th>Tipo</th>
                            <th>Clave Publica</th>
                            <th>Clave Secreta</th>
                            <th>Id Comerciante</th>
                            <th>Estatus</th>
                            <th>Prioridad</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pasarelasPago.map(item => (
                            <tr key={item.idPaymentGateway}>
                                <td>{item.idPaymentGateway}</td>
                                <td>{item.gatewayName}</td>
                                <td>{item.gatewayType}</td>
                                <td>{item.publicKey}</td>
                                <td>{item.secretKey}</td>
                                <td>{item.merchantId}</td>
                                <td>{item.isActive}</td>
                                <td>{item.priority}</td>
                                <td>

                                    <button className='eliminar' onClick={() => actualizarEstatusPasarela(item.idPaymentGateway, item.isActive)}>
                                        <FontAwesomeIcon icon={item.isActive === 1 ? faToggleOn : faToggleOff} />
                                    </button>
                                    <button className='editar' onClick={() => abrirModal(item)}>
                                        <FontAwesomeIcon icon={faEdit} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>

                </table>
            </div>
        </div>
    );
};
